module.exports = __webpack_public_path__ + "img/orange-booth-table-6.5a05b98e.png";